// Options doc: https://github.com/fengyuanchen/compressorjs/blob/main/README.md#options
var defaultFitStrategy = function defaultFitStrategy(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return {
    width: width,
    height: height
  };
};

var fitCrop = function fitCrop(_ref2) {
  var width = _ref2.width,
      height = _ref2.height;
  return {
    width: width,
    height: height,
    resize: 'cover'
  };
};

var fitMax = function fitMax(_ref3) {
  var width = _ref3.width,
      height = _ref3.height;
  return {
    maxWidth: width,
    maxHeight: height
  };
};

var fitClip = function fitClip(_ref4) {
  var width = _ref4.width,
      height = _ref4.height;
  return {
    width: width,
    height: height,
    maxWidth: width,
    maxHeight: height
  };
};

var formatsList = {
  jpg: 'image/jpeg',
  png: 'image/png'
};
var fitStrategy = {
  crop: fitCrop,
  max: fitMax,
  clip: fitClip
};

var CompressorConfig = function CompressorConfig() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var convertOptions = props.convertOptions;

  var _ref5 = convertOptions || {},
      quality = _ref5.quality,
      format = _ref5.format,
      fit = _ref5.fit,
      width = _ref5.width,
      height = _ref5.height;

  var options = width && height ? (fitStrategy[fit] || defaultFitStrategy)(convertOptions) : {};
  options.strict = true;
  options.checkOrientation = false;
  options.convertTypes = []; // compressor quality is less or equal 1

  if (quality) {
    options.quality = quality > 1 ? quality / 100.0 : quality;
  } else {
    options.quality = 1;
  }

  if (format && formatsList[format]) {
    options.mimeType = formatsList[format];
  }

  return options;
};

export default CompressorConfig;